import React, { useEffect, useState } from "react";
import Modal from "./Modal";
import {
  Button,
  Checkbox,
  DatePickerComp,
  Input,
  Select,
  Textarea,
  TimePickerComp,
} from "../Form";
import { BiChevronDown, BiPlus } from "react-icons/bi";
import { memberData, servicesData, sortsDatas } from "../Datas";
import { HiOutlineCheckCircle } from "react-icons/hi";
import { toast } from "react-hot-toast";
import moment from "moment";

function StaffModal({ closeModal, isOpen, datas }) {
  console.log({ datas });
  const [open, setOpen] = useState(false);

  const formatDuration = (mins) => {
    const hours = Math.floor(mins / 60);
    const minutes = mins % 60;
    if (hours && minutes) return `${hours} hr ${minutes} mins`;
    if (hours) return `${hours} hr`;
    return `${minutes} mins`;
  };

  const extractMinutes = (desc) => {
    const lower = desc?.toLowerCase() || "";
    const hrMatch = lower.match(/(\d+)\s*hr/);
    const minMatch = lower.match(/(\d+)\s*min/);

    const hr = hrMatch ? parseInt(hrMatch[1], 10) : 0;
    const min = minMatch ? parseInt(minMatch[1], 10) : 0;

    return hr * 60 + min;
  };

  const SectionCard = ({ title, children }) => (
    <div className="bg-none p-4 rounded-2xl shadow border border-border my-2">
      <h4 className="text-sm font-medium text-gray-400 uppercase tracking-wider mb-2">
        {title}
      </h4>
      <div>{children}</div>
    </div>
  );

  const serviceList = [
    ...datas.selectedNailServices,
    ...datas.selectedBeautyServices,
  ];

  return (
    <Modal
      closeModal={closeModal}
      isOpen={isOpen}
      title={"Appointment"}
      width={"max-w-3xl"}
    >
      <div className="flex-colo gap-6">
        <div className="w-full p-4 rounded-lg bg-slate-800  ">
          <div className="flex items-center gap-4 text-white border-b border-yellowlight shadow-sm p-4">
            <img
              src={datas?.user?.photo || ""}
              alt={datas?.user?.displayName}
              className="w-12 h-12 rounded-full object-cover border border-yellow-600"
            />
            <div className="flex flex-col">
              <h2 className="font-semibold text-lg uppercase border-b border-border">
                {datas?.user?.displayName || "Unknown"}
              </h2>
              <p className="text-sm text-slate-300">
                {datas?.customer_info?.mobile || "N/A"}
              </p>
              <p className="text-sm text-slate-300">
                {datas?.customer_info?.email || "N/A"}
              </p>
            </div>
          </div>
          <SectionCard title="Service">
            <div className="mt-4 text-sm">
              {serviceList?.length > 0 && (
                <div className="bg-white/10 p-4 rounded-2xl shadow border border-border w-full text-white">
                  {serviceList.map((item, i) => (
                    <div
                      key={item._id || i}
                      className="flex items-start space-x-2 mb-2"
                    >
                      <div className="w-6 h-6 bg-yellowlight rounded-md flex items-center justify-center mt-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-4 w-4 text-yellowdark"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M5 13l4 4L19 7"
                          />
                        </svg>
                      </div>
                      <p className="text-base font-medium">
                        {item.title}
                        {item.desc && (
                          <span className="text-sm text-gray-400">
                            {" "}
                            ({item.desc})
                          </span>
                        )}
                      </p>
                    </div>
                  ))}

                  {/* Total duration */}
                  <p className="text-right text-yellowlight font-medium mt-3">
                    Total:{" "}
                    {formatDuration(
                      serviceList.reduce(
                        (total, s) => total + extractMinutes(s.desc),
                        0
                      )
                    )}
                  </p>
                </div>
              )}
            </div>
          </SectionCard>
          <SectionCard title="Appointment Time">
            {datas?.selectedDateTime && (
              <div className="bg-white/10 p-4 rounded-2xl shadow border border-border w-full text-white">
                <p className="text-lg font-semibold">
                  {moment(datas.selectedDateTime).format("dddd, MMMM D, YYYY")}
                  <br />
                  <span className="text-yellowlight">
                    {moment(datas.selectedDateTime).format("hh:mm A")} -{" "}
                    {moment(datas.selectedDateTime).format("hh:mm A")}
                  </span>
                </p>
              </div>
            )}
          </SectionCard>
          <SectionCard title="STAFF">
            {datas?.selectedProfessional && (
              <div className="bg-white/10 p-4 rounded-2xl shadow border border-border w-full text-white">
                <div className="flex items-center gap-4">
                  <img
                    src={datas?.selectedProfessional?.photo} // 🔄 If you have actual staff photo, replace with staff photo source
                    alt={datas.staffName}
                    className="w-12 h-12 rounded-full object-cover border border-yellowlight"
                  />
                  <div className="flex flex-col">
                    <p className="text-lg font-semibold text-white">
                      {datas.selectedProfessional?.name}
                    </p>
                    {/* Optional role or badge */}
                    <span className="text-sm text-slate-400">Professional</span>
                  </div>
                </div>
              </div>
            )}
          </SectionCard>
          <SectionCard title="Customer's message">
            {datas?.customer_info?.message && (
              <div className="bg-white/10 p-4 rounded-2xl shadow border border-border w-full text-white">
                <p className="text-lg font-semibold">
                  {datas?.customer_info?.message || "-"}
                  <br />
                </p>
              </div>
            )}
          </SectionCard>
        </div>
        <div className="grid sm:grid-cols-2 gap-4 w-full">
          <button
            onClick={closeModal}
            className="bg-red-600 bg-opacity-5 text-red-600 text-sm p-4 rounded-lg font-light"
          >
            {datas?.title ? "Close" : "Cancel"}
          </button>
          <Button
            label="Confirm"
            Icon={HiOutlineCheckCircle}
            onClick={() => {
              toast.error("This feature is not available yet");
            }}
          />
        </div>
      </div>
    </Modal>
  );
}

export default StaffModal;
